export default {
  methods: {
    getSubtitleDisplay(subtitle) {
      return subtitle.language.code +
        (subtitle.hardcoded ? ' [ENC]' : '') +
        (subtitle.closedCaption ? ' [CC]' : '') +
        (subtitle.sdh ? ' [SDH]' : '');
    },
    getSubtitleDisplayFull(subtitle) {
      const name = subtitle.language.name ?? subtitle.language.code ?? '';

      return name +
        (subtitle.hardcoded ? ' [ENC]' : '') +
        (subtitle.closedCaption ? ' [CC]' : '') +
        (subtitle.sdh ? ' [SDH]' : '');
    },
    subtitlesMatch(a, b) {
      return a.language.id === b.language.id &&
        a.closedCaption === b.closedCaption &&
        a.hardcoded === b.hardcoded &&
        a.sdh === b.sdh;
    },
  },
};
